import { Castle, Church } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMG } from "@/constants/assets";

export function Realisations() {
  const { t } = useLanguage();
  const projects = [
    {
      testid: "realisation-card-veauce",
      img: IMG.veauce,
      icon: <Castle size={14} />,
      badge: t("rea_badge1"),
      title: t("veauce_t"),
      desc: t("veauce_d"),
      place: "Veauce · Allier · Auvergne",
    },
    {
      testid: "realisation-card-vains",
      img: IMG.vains,
      icon: <Church size={14} />,
      badge: t("rea_badge2"),
      title: t("vains_t"),
      desc: t("vains_d"),
      place: "Vains · Manche · Normandie",
    },
  ];

  return (
    <section id="realisations" data-testid="realisations-section" className="relative py-28 md:py-40 bg-[#14120F]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal><Kicker>{t("rea_kicker")}</Kicker></Reveal>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal delay={0.1}>
            <h2 className="font-serif-d text-4xl md:text-6xl mt-6 text-[#F7F4EE]">{t("rea_title")}</h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-sm text-[#B8B0A2] max-w-xs md:text-right">{t("rea_sub")}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid lg:grid-cols-2 gap-8">
          {projects.map((p, i) => (
            <Reveal key={p.testid} delay={i * 0.15} y={60}>
              <article data-testid={p.testid} className="group">
                <div className="img-frame relative aspect-[16/11]">
                  <img src={p.img} alt={p.title} className="w-full h-full object-cover" loading="lazy" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0B0A08]/80 via-transparent to-transparent" />
                  <span className="absolute top-5 left-5 inline-flex items-center gap-2 bg-[#0B0A08]/80 backdrop-blur-sm border border-[#D4AF37]/50 px-4 py-2 text-[10px] font-mono-d tracking-[0.25em] uppercase text-[#D4AF37]">
                    {p.icon} {p.badge}
                  </span>
                </div>
                <div className="border-x border-b hairline p-7 md:p-9 bg-[#0B0A08]/60 group-hover:border-[rgba(212,175,55,0.5)] transition-colors duration-500">
                  <span className="font-mono-d text-[10px] tracking-[0.3em] uppercase text-[#7A7367]">{p.place}</span>
                  <h3 className="font-serif-d text-3xl md:text-4xl mt-3 text-[#F7F4EE]">{p.title}</h3>
                  <p className="mt-4 text-sm text-[#B8B0A2] leading-relaxed">{p.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-20 grid grid-cols-2 md:grid-cols-4 border hairline divide-x divide-[rgba(197,160,89,0.15)]">
            {[
              ["120+", "Fenêtres historiques restaurées"],
              ["02", "Monuments d'exception"],
              ["15", "Ans de haute menuiserie"],
              ["20", "Langues parlées à l'atelier"],
            ].map(([n, label]) => (
              <div key={label} className="p-6 md:p-8 text-center">
                <div className="font-serif-d text-4xl md:text-5xl gold-text">{n}</div>
                <div className="mt-2 text-[11px] font-mono-d tracking-[0.15em] uppercase text-[#7A7367]">{label}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
